export class ChargeResponse {
    paymentReference?: string;
    processorId?: string;
    transactionId?: string;
    message?: string;
    /**
     * returns the debitedAmount
     */
    amount?: number;

    constructor(option?: ChargeResponseOption) {
        if (option) {
            this.paymentReference = option.paymentReference || '';
            this.processorId = option.processorId || '';
            this.transactionId = option.transactionId || '';
            this.message = option.message || '';
            this.amount = option.debitedAmount || null;
        }
    }
}

interface ChargeResponseOption {
    paymentReference?: string;
    processorId?: string;
    transactionId?: string;
    message?: string;
    debitedAmount?: number;
}


// WEBPACK FOOTER //
// ../inline/src/modules/shared/models/charge-response.model.ts